import React from 'react';

const nodes = [
  {
    n: '1',
    label: 'Step 1 · Welcome',
    title: 'Replies in under a minute, 24/7',
    desc: "The prospect writes at 11pm on a Sunday. Salesyo answers right away, in your voice, and engages before the interest cools off.",
    bubble: (
      <>
        <div className="mini-msg u">Hey, I came across your offer. What is it exactly?</div>
        <div className="mini-msg a">Hey 👋 glad it caught your eye. In short: we help you turn your inbound messages into clients. What's your field, so I can give you a precise answer?</div>
      </>
    )
  },
  {
    n: '2',
    label: 'Step 2 · Qualify',
    title: 'Knows who deserves your time',
    desc: "Need, budget, timing, decision-maker: Salesyo qualifies smoothly, with no interrogation. You stop losing hours on tire-kickers who'll never buy.",
    bubble: (
      <>
        <div className="mini-msg u">I'm a coach, but I barely get any calls booked.</div>
        <div className="mini-msg a">Got it. So the issue is the volume of qualified conversations, not the offer. What's your average deal size today?</div>
        <span className="mini-tag">🌤 Warm lead detected</span>
      </>
    )
  },
  {
    n: '3',
    label: 'Step 3 · Objection',
    title: 'Handles pushback like a salesperson',
    desc: "\"It's expensive\", \"I'll think about it\", \"I can do it myself\". Salesyo reframes the real concern and restates the value, using sales technique instead of a rigid script.",
    bubble: (
      <>
        <div className="mini-msg u">Honestly, I can handle my DMs myself.</div>
        <div className="mini-msg a">Totally, as long as you're available. The catch is the 11pm and weekend messages: that's where most prospects slip away. Those are the sales we recover.</div>
      </>
    )
  },
  {
    n: '4',
    label: 'Step 4 · Close',
    title: 'Closes based on context',
    desc: "A meeting on the calendar, a direct sale, or a sign-up: Salesyo picks the outcome that fits your offer and triggers it. Then hands over to you at exactly the right moment.",
    bubble: (
      <>
        <div className="mini-msg a">We have a slot Thursday 2pm to show you how to go from 5 to 20+ calls a month. Want me to lock it in?</div>
        <div className="mini-msg u">Yes, perfect</div>
        <div className="mini-msg a">Done ✅ The link is on its way.</div>
        <span className="mini-tag">🔥 Meeting booked · no human involved</span>
      </>
    )
  }
];

function FullCycle() {
  return (
    <section id="cycle">
      <div className="wrap">
        <div className="sec-head">
          <div className="eyebrow">The full cycle</div>
          <h2>A conversation doesn't end at "booking a call"</h2>
          <p>Where other tools book a slot and stop, Salesyo drives the conversation from the very first message to the close. Here's how a casual question turns into revenue.</p>
        </div>
        <div className="thread">
          {nodes.map((node) => (
            <div className="node" key={node.n}>
              <div className="side-txt">
                <div className="stage-label">{node.label}</div>
                <h3>{node.title}</h3>
                <p>{node.desc}</p>
              </div>
              <div className="side-bubble">
                <div className="bubble-demo">{node.bubble}</div>
              </div>
              <div className="dot-mark">{node.n}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FullCycle;
